import { DateTime } from 'luxon';

import { i18n } from 'i18n';
import { EMPTY_VALUE_INDICATOR, convertToDateString } from 'theSource/utils';
import { PrimitiveFieldValue, FieldDataType, Option } from 'theSource/types';

export const getDisplayValue = (
  value: PrimitiveFieldValue,
  dataType: FieldDataType,
  options: Option[]
) => {
  if (dataType === 'BOOLEAN') {
    return value ? i18n.t('common:yes') : i18n.t('common:no');
  }

  if (!value) {
    return EMPTY_VALUE_INDICATOR;
  }

  if (dataType === 'DATE') {
    return convertToDateString(value as DateTime);
  }

  if (options.length) {
    const selectedOption = options.find(
      (option) => option.value === value.toString()
    ) || { label: EMPTY_VALUE_INDICATOR };

    if (!selectedOption) {
      throw new Error(`Option with value ${value} does not exist`);
    }

    return selectedOption.label;
  }

  return value.toString();
};
